export const DASHBOARD = "/";

export const PLATFORM = "/platform";
export const PLATFORM_CLUBS = "/platform/clubs";
export const PLATFORM_USERS = "/platform/users";
export const PLATFORM_VAULTS = "/platform/vaults";
export const PLATFORM_PROPOSALS = "/platform/proposals";
export const PLATFORM_WITHDRAWAL = "/platform/withdrawal";
export const PLATFORM_STAKING = "/platform/staking";

export const CLUBS = "/clubs";
export const USERS = "/users";
export const SETTINGS = "/settings";
export const LOGIN = "/login";
export const REGISTER = "/register";
